import { toast } from "react-toastify";
import { useGlobalStore } from "../context/UserContext/userContext";
import { AUTH_SOURCE } from "../constants/authSource";
import { CRE_LOGIN_PATH } from "../constants/routes";

export function formatDateForInput(dateString) {
  if (!dateString) return "";
  // Handles ISO strings with or without time
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "";
  return d.toISOString().slice(0, 10);
}

/** Format date for display (e.g. "25 Jan 2025" or "Jan 25, 2025") */
export function formatDateForDisplay(dateString, locale = "en-IN", options = {}) {
  if (!dateString) return "—";
  const d = new Date(dateString);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(locale, {
    day: "numeric",
    month: "short",
    year: "numeric",
    ...options,
  });
}

export const computeAge = (dob) => {
  if (!dob) return "";
  const birthDate = new Date(dob);
  if (Number.isNaN(birthDate.getTime())) return "";
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return String(age);
};

export const formatStudyData = (data) => ({
  userId: data?.userId || "",
  studyId: data?.studyId || "",
  patientId: data?.patientId || "",
  patientName:
    data?.firstName || data?.lastName
      ? data.firstName + " " + data.lastName
      : "",
  accessionNo: data?.accNo || "",
  dateOfBirth: data?.dateOfBirth || "",
  modalityCode: data?.mrn || "",
  patientSex: data?.gender || "",
  insuranceName: data?.insuranceName || "",
  insuranceNumber: data?.insuranceNumber || "",
  weight: data?.weight || "",
});

const REDIRECT_ON_EXPIRY_MS = 2000;
const RADICAL_WEB_URL = "https://devrad4vetsfrontend.azurewebsites.net";

let tokenExpiredHandling = false;

/**
 * Call on 401 / token expiry. Clears auth state then:
 * - CRE → /cre login
 * - Radical embed → Radical frontend
 */
export const handleTokenExpired = () => {
  if (tokenExpiredHandling) return;
  tokenExpiredHandling = true;
  const store = useGlobalStore.getState();
  const { authSource } = store;
  const wasCre = authSource === AUTH_SOURCE.CRE;

  store.clear();
  toast.error("Session expired. Please sign in again.");

  setTimeout(async () => {
    if (wasCre) {
      try {
        const { initializeCreMsal, getCreMsalInstance } = await import(
          "../cre/creMsalInstance"
        );
        await initializeCreMsal();
        await getCreMsalInstance().clearCache();
      } catch (_) {
        /* ignore */
      }
      window.location.href = `${window.location.origin}${CRE_LOGIN_PATH}`;
      return;
    }
    window.location.href = RADICAL_WEB_URL;
  }, REDIRECT_ON_EXPIRY_MS);
};

/**
 * Replace video URL domain before it reaches end-user
 * Replaces rads4vets.blob.core.windows.net with medilis-media-cmayecgpa5hee8b5.z02.azurefd.net
 * @param {string} url - Video URL to process
 * @returns {string} - URL with replaced domain
 */
export const replaceVideoUrlDomain = (url) => {
  if (!url || typeof url !== "string") return url;
  // Replace rads4vets.blob.core.windows.net with medilis-media-cmayecgpa5hee8b5.z02.azurefd.net
  return url.replace(
    /rads4vets\.blob\.core\.windows\.net/g,
    "medilis-media-cmayecgpa5hee8b5.z02.azurefd.net"
  );
};
